import React, { createContext, useContext, useState, ReactNode } from 'react';
import { StockScreenerData } from '../components/screener/columnDefinitions';

interface SelectedStockContextType {
  selectedStock: StockScreenerData | null;
  setSelectedStock: (stock: StockScreenerData | null) => void;
  clearSelectedStock: () => void;
}

const SelectedStockContext = createContext<SelectedStockContextType | undefined>(undefined);

export const useSelectedStock = () => {
  const context = useContext(SelectedStockContext);
  if (context === undefined) {
    throw new Error('useSelectedStock must be used within a SelectedStockProvider');
  }
  return context;
};

interface SelectedStockProviderProps {
  children: ReactNode;
}

export const SelectedStockProvider: React.FC<SelectedStockProviderProps> = ({ children }) => {
  const [selectedStock, setSelectedStock] = useState<StockScreenerData | null>(null);

  const clearSelectedStock = () => {
    setSelectedStock(null);
  };

  return (
    <SelectedStockContext.Provider
      value={{
        selectedStock,
        setSelectedStock,
        clearSelectedStock
      }}
    >
      {children}
    </SelectedStockContext.Provider>
  );
};